import { Settings } from 'lucide-react';
import { useCurrentStateAndParams } from '@uirouter/react';

import { CertificateDetails } from '@/react/edge/components/CertificateModal/CertificateModal';

import { Icon } from '@@/Icon';
import { PageHeader } from '@@/PageHeader';

import { useEndpointMTLSCertificate } from './queries/useEndpointMTLSCertificate';
import styles from './MTLSCertificateView.module.css';

export function MTLSCertificateView() {
  const {
    params: { id: environmentId },
  } = useCurrentStateAndParams();

  if (!environmentId) {
    throw new Error('Missing id parameter');
  }

  const mtlsCertificateQuery = useEndpointMTLSCertificate(environmentId);

  return (
    <>
      <PageHeader
        title="mTLS Certificate"
        breadcrumbs="Environment summary"
        reload
      />

      <div className="mx-4">
        {mtlsCertificateQuery.data?.MTLSCertificate ? (
          <CertificateDetails
            certificate={mtlsCertificateQuery.data?.MTLSCertificate}
          />
        ) : (
          <div className={styles.root}>
            Getting edge environment mTLS certificate...
            <Icon icon={Settings} className="!ml-1 animate-spin-slow" />
          </div>
        )}
      </div>
    </>
  );
}
